
import {
  RESET_MESSAGES
} from "./types";

export const resetMessage = () => async (dispatch) => {
    dispatch({ type: RESET_MESSAGES});
      
}
